export default __webpack_public_path__ + "static/media/head-left-side.5bf8127f.png";